<template>
  <v-dialog v-model="dialogState" max-width="800" persistent>
    <v-card>

      <v-toolbar
        color="primary"
        flat
        short
      >
        <v-toolbar-title>{{ $t('Stock') }} ({{ this.locationTitle }})</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="hideDialog" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>

        <v-form
          autocomplete="off"
        >
          <v-container class="mt-5">
            <v-row>
              <v-col cols="6" sm="6">
                <v-select
                  v-model="model.type"
                  :items="product_types"
                  :label="$t('Type')"
                  :error-messages="errors.type"
                  dense
                ></v-select>
                <v-text-field
                  v-model="model.quantity_available"
                  :label="$t('Quantity available')"
                  :error-messages="errors.quantity_available"
                  autocomplete="off"
                ></v-text-field>
                <v-text-field
                  v-model="model.quantity_threshold"
                  :label="$t('Quantity threshold')"
                  :error-messages="errors.quantity_threshold"
                  autocomplete="off"
                ></v-text-field>
                <v-text-field
                  v-model="model.quantity_unit"
                  :label="$t('Quantity unit')"
                  :error-messages="errors.quantity_unit"
                  autocomplete="off"
                ></v-text-field>
                <v-text-field 
                  v-for="language in languages"
                  v-model="model.product_names[language.code]"
                  :key="language.code"
                  :label="$t('Name') + ' ( '+ language.description +' ) '"
                  :error-messages="errors.product_names"
                  autocomplete="off"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions class="px-10 pb-10">
        <v-btn color="warning" @click="deleteItem" v-if="!isNewItem">{{ $t('Delete') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="saveItem">{{ isNewItem ? $t('Create') : $t('Save') }}</v-btn>
        <v-btn color="default" @click="hideDialog">{{ $t('Cancel') }}</v-btn>
      </v-card-actions>

    </v-card>

	<ErrorFlash v-model="errors"/>
  </v-dialog>
</template>

<script>
import ApiService from '@/services/api.service'
import ErrorFlash from '@/components/ErrorFlash'

export default {
  props: {
    'locationTag': String,
    'locationTitle': String,
  },
  components: {
    ErrorFlash,
  },
  data () {
    return {
      dialogState: false,
      deliveryDateDialog: false,
      location: this.locationTag,
      model: {
        product_names: {}
      },
      errors: {},
    }
  },
  watch: {

  },
  computed: {
    product_types() {
        return [this.$t('drug'),this.$t('supply')]
    },
    isNewItem() {
      return !this.model.id
    },
    languages() {
        return this.$store.getters['language/getList']
    },
  },
  created() {
  },
  methods: {
    showDialog(id = null) {
      if (id !== null) {
        this.fetchItem(id)
      }
      this.dialogState = true
    },
    hideDialog() {
      this.dialogState = false

      // resetting the form, unset only the id, the rest will be overwritten by an empty model from the api controller.
      this.model = {
        product_names: {}
      }
      //this.setItem({}, true) // reset fields
    },
    setItem(item = {}, reset = false) {
      Object.keys(this.model).forEach(key => {
        if (reset || (key in item)) {
          if (this.model[key].isArray()) {
            this.setItem(this.model[key])
          } else {
            this.model[key] = (key in item) ? item[key] : null
          }
        }
      })
      this.errors = {}      
    },
    getItem() {
      const item = this.model
      return item
    },
    fetchItem(id) {
      this.$store.dispatch('session/showLoader')
      this.errors = {}
      ApiService.view(`/stock/${id}`, {
        params: {
        },
      }).then(item => {
        //this.setItem(item, true)
        delete item.product_name
        this.model = item
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
    saveItem() {
      this.model['location'] = this.locationTag

      this.errors = {}
      this.$store.dispatch('session/showLoader')
      if (this.model.id) {
        ApiService.update(`/stock/${this.model.id}`, {
          ...this.getItem(),
        }).then(item => {
          this.$emit('update', item)
          this.hideDialog()
        }).catch(errors => {
          this.errors = errors
        }).finally(() => {
          this.$store.dispatch('session/hideLoader')
        })
      } else {
        ApiService.create('/stock', {
          ...this.getItem(),
          //'values': this.model.values,
        }).then(item => {
          //this.setItem(item)
          this.$emit('update', item)
          this.hideDialog()
        }).catch(errors => {
          this.errors = errors
        }).finally(() => {
          this.$store.dispatch('session/hideLoader')
        })
      }
    },
    deleteItem() {
      this.errors = {}
      this.$store.dispatch('session/showLoader')

      ApiService.delete(`/stock/${this.model.id}`)
      .then(item => {
        this.$emit('update', item)
        this.hideDialog()
      }).catch(errors => {
        this.errors = errors
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
  },
}
</script>
